import { useEffect, useRef } from "react";
import { useMailContactsOptional } from "@/hooks/useMailContacts";
import { parseAddressFieldEntries } from "@/lib/mail/parseAddressField";
import type { MailMessageSummary } from "@/lib/types/mail";

/** Collecte silencieuse des adresses visibles (liste + message ouvert). */
export function useCollectMailContacts(
  messages: MailMessageSummary[],
  readerFrom?: string | null,
  readerTo?: string | null
): void {
  const contacts = useMailContactsOptional();
  const lastKeyRef = useRef("");

  useEffect(() => {
    if (!contacts) return;

    const entries = [];
    for (const msg of messages.slice(0, 50)) {
      if (msg.from?.trim()) {
        entries.push(...parseAddressFieldEntries(msg.from));
      }
    }
    if (readerFrom?.trim()) entries.push(...parseAddressFieldEntries(readerFrom));
    if (readerTo?.trim()) entries.push(...parseAddressFieldEntries(readerTo));

    if (entries.length === 0) return;

    const key = entries
      .map((e) => e.email)
      .sort()
      .join("|");
    if (key === lastKeyRef.current) return;
    lastKeyRef.current = key;

    contacts.collectEntries(entries);
  }, [contacts, messages, readerFrom, readerTo]);
}
